var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// types/src/types.ajv.ts
__export(exports, {
  JobStatus: () => JobStatus,
  assertAnonymous1: () => assertAnonymous1,
  assertAnonymous10: () => assertAnonymous10,
  assertAnonymous10Json: () => assertAnonymous10Json,
  assertAnonymous11: () => assertAnonymous11,
  assertAnonymous11Json: () => assertAnonymous11Json,
  assertAnonymous12: () => assertAnonymous12,
  assertAnonymous15: () => assertAnonymous15,
  assertAnonymous15Json: () => assertAnonymous15Json,
  assertAnonymous16: () => assertAnonymous16,
  assertAnonymous16Json: () => assertAnonymous16Json,
  assertAnonymous17: () => assertAnonymous17,
  assertAnonymous18: () => assertAnonymous18,
  assertAnonymous18Json: () => assertAnonymous18Json,
  assertAnonymous19: () => assertAnonymous19,
  assertAnonymous19Json: () => assertAnonymous19Json,
  assertAnonymous1Json: () => assertAnonymous1Json,
  assertAnonymous2: () => assertAnonymous2,
  assertAnonymous20: () => assertAnonymous20,
  assertAnonymous23: () => assertAnonymous23,
  assertAnonymous23Json: () => assertAnonymous23Json,
  assertAnonymous24: () => assertAnonymous24,
  assertAnonymous24Json: () => assertAnonymous24Json,
  assertAnonymous25: () => assertAnonymous25,
  assertAnonymous25Json: () => assertAnonymous25Json,
  assertAnonymous26: () => assertAnonymous26,
  assertAnonymous26Json: () => assertAnonymous26Json,
  assertAnonymous27: () => assertAnonymous27,
  assertAnonymous28: () => assertAnonymous28,
  assertAnonymous28Json: () => assertAnonymous28Json,
  assertAnonymous29: () => assertAnonymous29,
  assertAnonymous29Json: () => assertAnonymous29Json,
  assertAnonymous2Json: () => assertAnonymous2Json,
  assertAnonymous3: () => assertAnonymous3,
  assertAnonymous30: () => assertAnonymous30,
  assertAnonymous31: () => assertAnonymous31,
  assertAnonymous31Json: () => assertAnonymous31Json,
  assertAnonymous32: () => assertAnonymous32,
  assertAnonymous32Json: () => assertAnonymous32Json,
  assertAnonymous33: () => assertAnonymous33,
  assertAnonymous34: () => assertAnonymous34,
  assertAnonymous34Json: () => assertAnonymous34Json,
  assertAnonymous35: () => assertAnonymous35,
  assertAnonymous35Json: () => assertAnonymous35Json,
  assertAnonymous36: () => assertAnonymous36,
  assertAnonymous39: () => assertAnonymous39,
  assertAnonymous39Json: () => assertAnonymous39Json,
  assertAnonymous3Json: () => assertAnonymous3Json,
  assertAnonymous4: () => assertAnonymous4,
  assertAnonymous40: () => assertAnonymous40,
  assertAnonymous40Json: () => assertAnonymous40Json,
  assertAnonymous41: () => assertAnonymous41,
  assertAnonymous41Json: () => assertAnonymous41Json,
  assertAnonymous42: () => assertAnonymous42,
  assertAnonymous42Json: () => assertAnonymous42Json,
  assertAnonymous43: () => assertAnonymous43,
  assertAnonymous43Json: () => assertAnonymous43Json,
  assertAnonymous44: () => assertAnonymous44,
  assertAnonymous44Json: () => assertAnonymous44Json,
  assertAnonymous45: () => assertAnonymous45,
  assertAnonymous45Json: () => assertAnonymous45Json,
  assertAnonymous46: () => assertAnonymous46,
  assertAnonymous46Json: () => assertAnonymous46Json,
  assertAnonymous47: () => assertAnonymous47,
  assertAnonymous48: () => assertAnonymous48,
  assertAnonymous48Json: () => assertAnonymous48Json,
  assertAnonymous5: () => assertAnonymous5,
  assertAnonymous5Json: () => assertAnonymous5Json,
  assertAnonymous6: () => assertAnonymous6,
  assertAnonymous9: () => assertAnonymous9,
  assertAnonymous9Json: () => assertAnonymous9Json,
  assertCreateBugRequest: () => assertCreateBugRequest,
  assertCreateBugRequestJson: () => assertCreateBugRequestJson,
  assertCreateBugResponse: () => assertCreateBugResponse,
  assertCreateFeedbackRequest: () => assertCreateFeedbackRequest,
  assertCreateFeedbackRequestJson: () => assertCreateFeedbackRequestJson,
  assertCreateFeedbackResponse: () => assertCreateFeedbackResponse,
  assertCreateFeedbackResponseJson: () => assertCreateFeedbackResponseJson,
  assertCreateJobRequest: () => assertCreateJobRequest,
  assertCreateJobRequestJson: () => assertCreateJobRequestJson,
  assertCreateJobResponse: () => assertCreateJobResponse,
  assertCreateUserRequest: () => assertCreateUserRequest,
  assertCreateUserRequestJson: () => assertCreateUserRequestJson,
  assertCreateUserResponse: () => assertCreateUserResponse,
  assertDeleteJobRequest: () => assertDeleteJobRequest,
  assertDeleteJobRequestPathParameters: () => assertDeleteJobRequestPathParameters,
  assertDeleteJobResponse: () => assertDeleteJobResponse,
  assertFile: () => assertFile,
  assertGeneratePresignedUrlRequest: () => assertGeneratePresignedUrlRequest,
  assertGeneratePresignedUrlRequestPathParameters: () => assertGeneratePresignedUrlRequestPathParameters,
  assertGeneratePresignedUrlRequestQueryStringParameters: () => assertGeneratePresignedUrlRequestQueryStringParameters,
  assertGeneratePresignedUrlResponse: () => assertGeneratePresignedUrlResponse,
  assertGetJobByIdRequest: () => assertGetJobByIdRequest,
  assertGetJobByIdRequestPathParameters: () => assertGetJobByIdRequestPathParameters,
  assertGetJobByIdResponse: () => assertGetJobByIdResponse,
  assertGetMetricsRequest: () => assertGetMetricsRequest,
  assertGetMetricsResponse: () => assertGetMetricsResponse,
  assertGetResultArchiveRequest: () => assertGetResultArchiveRequest,
  assertGetResultArchiveRequestPathParameters: () => assertGetResultArchiveRequestPathParameters,
  assertGetResultArchiveResponse: () => assertGetResultArchiveResponse,
  assertGetUserRequest: () => assertGetUserRequest,
  assertGetUserResponse: () => assertGetUserResponse,
  assertJob: () => assertJob,
  assertJobAdvancedParameters: () => assertJobAdvancedParameters,
  assertJobStatus: () => assertJobStatus,
  assertJobStatusEntry: () => assertJobStatusEntry,
  assertListInputRequest: () => assertListInputRequest,
  assertListInputRequestPathParameters: () => assertListInputRequestPathParameters,
  assertListInputRequestQueryStringParameters: () => assertListInputRequestQueryStringParameters,
  assertListInputResponse: () => assertListInputResponse,
  assertListJobsRequest: () => assertListJobsRequest,
  assertListJobsResponse: () => assertListJobsResponse,
  assertListResultImagesRequest: () => assertListResultImagesRequest,
  assertListResultImagesRequestPathParameters: () => assertListResultImagesRequestPathParameters,
  assertListResultImagesResponse: () => assertListResultImagesResponse,
  assertListResultRequest: () => assertListResultRequest,
  assertListResultRequestPathParameters: () => assertListResultRequestPathParameters,
  assertListResultResponse: () => assertListResultResponse,
  assertProtein: () => assertProtein,
  assertSubmitInputRequest: () => assertSubmitInputRequest,
  assertSubmitInputRequestPathParameters: () => assertSubmitInputRequestPathParameters,
  assertSubmitInputRequestQueryStringParameters: () => assertSubmitInputRequestQueryStringParameters,
  assertSubmitInputResponse: () => assertSubmitInputResponse,
  assertSubmitJobRequest: () => assertSubmitJobRequest,
  assertSubmitJobRequestJson: () => assertSubmitJobRequestJson,
  assertSubmitJobRequestJsonAdvancedParameters: () => assertSubmitJobRequestJsonAdvancedParameters,
  assertSubmitJobRequestJsonUseSpotInstance: () => assertSubmitJobRequestJsonUseSpotInstance,
  assertSubmitJobRequestPathParameters: () => assertSubmitJobRequestPathParameters,
  assertSubmitJobResponse: () => assertSubmitJobResponse,
  assertUpdateUserRequest: () => assertUpdateUserRequest,
  assertUpdateUserRequestJson: () => assertUpdateUserRequestJson,
  assertUpdateUserResponse: () => assertUpdateUserResponse,
  assertUser: () => assertUser,
  assertUserMetrics: () => assertUserMetrics,
  routes: () => routes,
  validators: () => validators
});
function assertFile(data) {
  if (exports.isFile(data))
    return;
  throw new ValidationError(exports.isFile.errors);
}
function assertJobAdvancedParameters(data) {
  if (exports.isJobAdvancedParameters(data))
    return;
  throw new ValidationError(exports.isJobAdvancedParameters.errors);
}
function assertUser(data) {
  if (exports.isUser(data))
    return;
  throw new ValidationError(exports.isUser.errors);
}
function assertJobStatus(data) {
  if (exports.isJobStatus(data))
    return;
  throw new ValidationError(exports.isJobStatus.errors);
}
var JobStatus;
(function(JobStatus2) {
  JobStatus2["creating"] = "creating";
  JobStatus2["created"] = "created";
  JobStatus2["queued"] = "queued";
  JobStatus2["running"] = "running";
  JobStatus2["finished"] = "finished";
  JobStatus2["error"] = "error";
  JobStatus2["submitted"] = "submitted";
  JobStatus2["pending"] = "pending";
  JobStatus2["runnable"] = "runnable";
  JobStatus2["starting"] = "starting";
  JobStatus2["succeeded"] = "succeeded";
  JobStatus2["failed"] = "failed";
})(JobStatus || (JobStatus = {}));
function assertJob(data) {
  if (exports.isJob(data))
    return;
  throw new ValidationError(exports.isJob.errors);
}
function assertJobStatusEntry(data) {
  if (exports.isJobStatusEntry(data))
    return;
  throw new ValidationError(exports.isJobStatusEntry.errors);
}
function assertProtein(data) {
  if (exports.isProtein(data))
    return;
  throw new ValidationError(exports.isProtein.errors);
}
function assertUserMetrics(data) {
  if (exports.isUserMetrics(data))
    return;
  throw new ValidationError(exports.isUserMetrics.errors);
}
function assertAnonymous1Json(data) {
  if (exports.isAnonymous1Json(data))
    return;
  throw new ValidationError(exports.isAnonymous1Json.errors);
}
function assertAnonymous1(data) {
  if (exports.isAnonymous1(data))
    return;
  throw new ValidationError(exports.isAnonymous1.errors);
}
function assertAnonymous2Json(data) {
  if (exports.isAnonymous2Json(data))
    return;
  throw new ValidationError(exports.isAnonymous2Json.errors);
}
function assertAnonymous2(data) {
  if (exports.isAnonymous2(data))
    return;
  throw new ValidationError(exports.isAnonymous2.errors);
}
function assertAnonymous3Json(data) {
  if (exports.isAnonymous3Json(data))
    return;
  throw new ValidationError(exports.isAnonymous3Json.errors);
}
function assertAnonymous3(data) {
  if (exports.isAnonymous3(data))
    return;
  throw new ValidationError(exports.isAnonymous3.errors);
}
function assertCreateBugResponse(data) {
  if (exports.isCreateBugResponse(data))
    return;
  throw new ValidationError(exports.isCreateBugResponse.errors);
}
function assertCreateBugRequestJson(data) {
  if (exports.isCreateBugRequestJson(data))
    return;
  throw new ValidationError(exports.isCreateBugRequestJson.errors);
}
function assertCreateBugRequest(data) {
  if (exports.isCreateBugRequest(data))
    return;
  throw new ValidationError(exports.isCreateBugRequest.errors);
}
function assertCreateFeedbackResponseJson(data) {
  if (exports.isCreateFeedbackResponseJson(data))
    return;
  throw new ValidationError(exports.isCreateFeedbackResponseJson.errors);
}
function assertCreateFeedbackResponse(data) {
  if (exports.isCreateFeedbackResponse(data))
    return;
  throw new ValidationError(exports.isCreateFeedbackResponse.errors);
}
function assertCreateFeedbackRequestJson(data) {
  if (exports.isCreateFeedbackRequestJson(data))
    return;
  throw new ValidationError(exports.isCreateFeedbackRequestJson.errors);
}
function assertCreateFeedbackRequest(data) {
  if (exports.isCreateFeedbackRequest(data))
    return;
  throw new ValidationError(exports.isCreateFeedbackRequest.errors);
}
function assertAnonymous4(data) {
  if (exports.isAnonymous4(data))
    return;
  throw new ValidationError(exports.isAnonymous4.errors);
}
function assertAnonymous5Json(data) {
  if (exports.isAnonymous5Json(data))
    return;
  throw new ValidationError(exports.isAnonymous5Json.errors);
}
function assertAnonymous5(data) {
  if (exports.isAnonymous5(data))
    return;
  throw new ValidationError(exports.isAnonymous5.errors);
}
function assertListJobsResponse(data) {
  if (exports.isListJobsResponse(data))
    return;
  throw new ValidationError(exports.isListJobsResponse.errors);
}
function assertListJobsRequest(data) {
  if (exports.isListJobsRequest(data))
    return;
  throw new ValidationError(exports.isListJobsRequest.errors);
}
function assertAnonymous6(data) {
  if (exports.isAnonymous6(data))
    return;
  throw new ValidationError(exports.isAnonymous6.errors);
}
function assertAnonymous9Json(data) {
  if (exports.isAnonymous9Json(data))
    return;
  throw new ValidationError(exports.isAnonymous9Json.errors);
}
function assertAnonymous9(data) {
  if (exports.isAnonymous9(data))
    return;
  throw new ValidationError(exports.isAnonymous9.errors);
}
function assertCreateJobResponse(data) {
  if (exports.isCreateJobResponse(data))
    return;
  throw new ValidationError(exports.isCreateJobResponse.errors);
}
function assertCreateJobRequestJson(data) {
  if (exports.isCreateJobRequestJson(data))
    return;
  throw new ValidationError(exports.isCreateJobRequestJson.errors);
}
function assertCreateJobRequest(data) {
  if (exports.isCreateJobRequest(data))
    return;
  throw new ValidationError(exports.isCreateJobRequest.errors);
}
function assertAnonymous10Json(data) {
  if (exports.isAnonymous10Json(data))
    return;
  throw new ValidationError(exports.isAnonymous10Json.errors);
}
function assertAnonymous10(data) {
  if (exports.isAnonymous10(data))
    return;
  throw new ValidationError(exports.isAnonymous10.errors);
}
function assertAnonymous11Json(data) {
  if (exports.isAnonymous11Json(data))
    return;
  throw new ValidationError(exports.isAnonymous11Json.errors);
}
function assertAnonymous11(data) {
  if (exports.isAnonymous11(data))
    return;
  throw new ValidationError(exports.isAnonymous11.errors);
}
function assertDeleteJobResponse(data) {
  if (exports.isDeleteJobResponse(data))
    return;
  throw new ValidationError(exports.isDeleteJobResponse.errors);
}
function assertDeleteJobRequestPathParameters(data) {
  if (exports.isDeleteJobRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isDeleteJobRequestPathParameters.errors);
}
function assertDeleteJobRequest(data) {
  if (exports.isDeleteJobRequest(data))
    return;
  throw new ValidationError(exports.isDeleteJobRequest.errors);
}
function assertAnonymous12(data) {
  if (exports.isAnonymous12(data))
    return;
  throw new ValidationError(exports.isAnonymous12.errors);
}
function assertAnonymous15Json(data) {
  if (exports.isAnonymous15Json(data))
    return;
  throw new ValidationError(exports.isAnonymous15Json.errors);
}
function assertAnonymous15(data) {
  if (exports.isAnonymous15(data))
    return;
  throw new ValidationError(exports.isAnonymous15.errors);
}
function assertAnonymous16Json(data) {
  if (exports.isAnonymous16Json(data))
    return;
  throw new ValidationError(exports.isAnonymous16Json.errors);
}
function assertAnonymous16(data) {
  if (exports.isAnonymous16(data))
    return;
  throw new ValidationError(exports.isAnonymous16.errors);
}
function assertGetJobByIdResponse(data) {
  if (exports.isGetJobByIdResponse(data))
    return;
  throw new ValidationError(exports.isGetJobByIdResponse.errors);
}
function assertGetJobByIdRequestPathParameters(data) {
  if (exports.isGetJobByIdRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isGetJobByIdRequestPathParameters.errors);
}
function assertGetJobByIdRequest(data) {
  if (exports.isGetJobByIdRequest(data))
    return;
  throw new ValidationError(exports.isGetJobByIdRequest.errors);
}
function assertAnonymous17(data) {
  if (exports.isAnonymous17(data))
    return;
  throw new ValidationError(exports.isAnonymous17.errors);
}
function assertAnonymous18Json(data) {
  if (exports.isAnonymous18Json(data))
    return;
  throw new ValidationError(exports.isAnonymous18Json.errors);
}
function assertAnonymous18(data) {
  if (exports.isAnonymous18(data))
    return;
  throw new ValidationError(exports.isAnonymous18.errors);
}
function assertAnonymous19Json(data) {
  if (exports.isAnonymous19Json(data))
    return;
  throw new ValidationError(exports.isAnonymous19Json.errors);
}
function assertAnonymous19(data) {
  if (exports.isAnonymous19(data))
    return;
  throw new ValidationError(exports.isAnonymous19.errors);
}
function assertListInputResponse(data) {
  if (exports.isListInputResponse(data))
    return;
  throw new ValidationError(exports.isListInputResponse.errors);
}
function assertListInputRequestPathParameters(data) {
  if (exports.isListInputRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isListInputRequestPathParameters.errors);
}
function assertListInputRequestQueryStringParameters(data) {
  if (exports.isListInputRequestQueryStringParameters(data))
    return;
  throw new ValidationError(exports.isListInputRequestQueryStringParameters.errors);
}
function assertListInputRequest(data) {
  if (exports.isListInputRequest(data))
    return;
  throw new ValidationError(exports.isListInputRequest.errors);
}
function assertAnonymous20(data) {
  if (exports.isAnonymous20(data))
    return;
  throw new ValidationError(exports.isAnonymous20.errors);
}
function assertAnonymous23Json(data) {
  if (exports.isAnonymous23Json(data))
    return;
  throw new ValidationError(exports.isAnonymous23Json.errors);
}
function assertAnonymous23(data) {
  if (exports.isAnonymous23(data))
    return;
  throw new ValidationError(exports.isAnonymous23.errors);
}
function assertAnonymous24Json(data) {
  if (exports.isAnonymous24Json(data))
    return;
  throw new ValidationError(exports.isAnonymous24Json.errors);
}
function assertAnonymous24(data) {
  if (exports.isAnonymous24(data))
    return;
  throw new ValidationError(exports.isAnonymous24.errors);
}
function assertAnonymous25Json(data) {
  if (exports.isAnonymous25Json(data))
    return;
  throw new ValidationError(exports.isAnonymous25Json.errors);
}
function assertAnonymous25(data) {
  if (exports.isAnonymous25(data))
    return;
  throw new ValidationError(exports.isAnonymous25.errors);
}
function assertAnonymous26Json(data) {
  if (exports.isAnonymous26Json(data))
    return;
  throw new ValidationError(exports.isAnonymous26Json.errors);
}
function assertAnonymous26(data) {
  if (exports.isAnonymous26(data))
    return;
  throw new ValidationError(exports.isAnonymous26.errors);
}
function assertSubmitInputResponse(data) {
  if (exports.isSubmitInputResponse(data))
    return;
  throw new ValidationError(exports.isSubmitInputResponse.errors);
}
function assertSubmitInputRequestPathParameters(data) {
  if (exports.isSubmitInputRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isSubmitInputRequestPathParameters.errors);
}
function assertSubmitInputRequestQueryStringParameters(data) {
  if (exports.isSubmitInputRequestQueryStringParameters(data))
    return;
  throw new ValidationError(exports.isSubmitInputRequestQueryStringParameters.errors);
}
function assertSubmitInputRequest(data) {
  if (exports.isSubmitInputRequest(data))
    return;
  throw new ValidationError(exports.isSubmitInputRequest.errors);
}
function assertAnonymous27(data) {
  if (exports.isAnonymous27(data))
    return;
  throw new ValidationError(exports.isAnonymous27.errors);
}
function assertAnonymous28Json(data) {
  if (exports.isAnonymous28Json(data))
    return;
  throw new ValidationError(exports.isAnonymous28Json.errors);
}
function assertAnonymous28(data) {
  if (exports.isAnonymous28(data))
    return;
  throw new ValidationError(exports.isAnonymous28.errors);
}
function assertAnonymous29Json(data) {
  if (exports.isAnonymous29Json(data))
    return;
  throw new ValidationError(exports.isAnonymous29Json.errors);
}
function assertAnonymous29(data) {
  if (exports.isAnonymous29(data))
    return;
  throw new ValidationError(exports.isAnonymous29.errors);
}
function assertListResultResponse(data) {
  if (exports.isListResultResponse(data))
    return;
  throw new ValidationError(exports.isListResultResponse.errors);
}
function assertListResultRequestPathParameters(data) {
  if (exports.isListResultRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isListResultRequestPathParameters.errors);
}
function assertListResultRequest(data) {
  if (exports.isListResultRequest(data))
    return;
  throw new ValidationError(exports.isListResultRequest.errors);
}
function assertAnonymous30(data) {
  if (exports.isAnonymous30(data))
    return;
  throw new ValidationError(exports.isAnonymous30.errors);
}
function assertAnonymous31Json(data) {
  if (exports.isAnonymous31Json(data))
    return;
  throw new ValidationError(exports.isAnonymous31Json.errors);
}
function assertAnonymous31(data) {
  if (exports.isAnonymous31(data))
    return;
  throw new ValidationError(exports.isAnonymous31.errors);
}
function assertAnonymous32Json(data) {
  if (exports.isAnonymous32Json(data))
    return;
  throw new ValidationError(exports.isAnonymous32Json.errors);
}
function assertAnonymous32(data) {
  if (exports.isAnonymous32(data))
    return;
  throw new ValidationError(exports.isAnonymous32.errors);
}
function assertGetResultArchiveResponse(data) {
  if (exports.isGetResultArchiveResponse(data))
    return;
  throw new ValidationError(exports.isGetResultArchiveResponse.errors);
}
function assertGetResultArchiveRequestPathParameters(data) {
  if (exports.isGetResultArchiveRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isGetResultArchiveRequestPathParameters.errors);
}
function assertGetResultArchiveRequest(data) {
  if (exports.isGetResultArchiveRequest(data))
    return;
  throw new ValidationError(exports.isGetResultArchiveRequest.errors);
}
function assertAnonymous33(data) {
  if (exports.isAnonymous33(data))
    return;
  throw new ValidationError(exports.isAnonymous33.errors);
}
function assertAnonymous34Json(data) {
  if (exports.isAnonymous34Json(data))
    return;
  throw new ValidationError(exports.isAnonymous34Json.errors);
}
function assertAnonymous34(data) {
  if (exports.isAnonymous34(data))
    return;
  throw new ValidationError(exports.isAnonymous34.errors);
}
function assertAnonymous35Json(data) {
  if (exports.isAnonymous35Json(data))
    return;
  throw new ValidationError(exports.isAnonymous35Json.errors);
}
function assertAnonymous35(data) {
  if (exports.isAnonymous35(data))
    return;
  throw new ValidationError(exports.isAnonymous35.errors);
}
function assertListResultImagesResponse(data) {
  if (exports.isListResultImagesResponse(data))
    return;
  throw new ValidationError(exports.isListResultImagesResponse.errors);
}
function assertListResultImagesRequestPathParameters(data) {
  if (exports.isListResultImagesRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isListResultImagesRequestPathParameters.errors);
}
function assertListResultImagesRequest(data) {
  if (exports.isListResultImagesRequest(data))
    return;
  throw new ValidationError(exports.isListResultImagesRequest.errors);
}
function assertAnonymous36(data) {
  if (exports.isAnonymous36(data))
    return;
  throw new ValidationError(exports.isAnonymous36.errors);
}
function assertAnonymous39Json(data) {
  if (exports.isAnonymous39Json(data))
    return;
  throw new ValidationError(exports.isAnonymous39Json.errors);
}
function assertAnonymous39(data) {
  if (exports.isAnonymous39(data))
    return;
  throw new ValidationError(exports.isAnonymous39.errors);
}
function assertAnonymous40Json(data) {
  if (exports.isAnonymous40Json(data))
    return;
  throw new ValidationError(exports.isAnonymous40Json.errors);
}
function assertAnonymous40(data) {
  if (exports.isAnonymous40(data))
    return;
  throw new ValidationError(exports.isAnonymous40.errors);
}
function assertAnonymous41Json(data) {
  if (exports.isAnonymous41Json(data))
    return;
  throw new ValidationError(exports.isAnonymous41Json.errors);
}
function assertAnonymous41(data) {
  if (exports.isAnonymous41(data))
    return;
  throw new ValidationError(exports.isAnonymous41.errors);
}
function assertAnonymous42Json(data) {
  if (exports.isAnonymous42Json(data))
    return;
  throw new ValidationError(exports.isAnonymous42Json.errors);
}
function assertAnonymous42(data) {
  if (exports.isAnonymous42(data))
    return;
  throw new ValidationError(exports.isAnonymous42.errors);
}
function assertAnonymous43Json(data) {
  if (exports.isAnonymous43Json(data))
    return;
  throw new ValidationError(exports.isAnonymous43Json.errors);
}
function assertAnonymous43(data) {
  if (exports.isAnonymous43(data))
    return;
  throw new ValidationError(exports.isAnonymous43.errors);
}
function assertSubmitJobResponse(data) {
  if (exports.isSubmitJobResponse(data))
    return;
  throw new ValidationError(exports.isSubmitJobResponse.errors);
}
function assertSubmitJobRequestPathParameters(data) {
  if (exports.isSubmitJobRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isSubmitJobRequestPathParameters.errors);
}
function assertSubmitJobRequestJsonAdvancedParameters(data) {
  if (exports.isSubmitJobRequestJsonAdvancedParameters(data))
    return;
  throw new ValidationError(exports.isSubmitJobRequestJsonAdvancedParameters.errors);
}
function assertSubmitJobRequestJsonUseSpotInstance(data) {
  if (exports.isSubmitJobRequestJsonUseSpotInstance(data))
    return;
  throw new ValidationError(exports.isSubmitJobRequestJsonUseSpotInstance.errors);
}
function assertSubmitJobRequestJson(data) {
  if (exports.isSubmitJobRequestJson(data))
    return;
  throw new ValidationError(exports.isSubmitJobRequestJson.errors);
}
function assertSubmitJobRequest(data) {
  if (exports.isSubmitJobRequest(data))
    return;
  throw new ValidationError(exports.isSubmitJobRequest.errors);
}
function assertAnonymous44Json(data) {
  if (exports.isAnonymous44Json(data))
    return;
  throw new ValidationError(exports.isAnonymous44Json.errors);
}
function assertAnonymous44(data) {
  if (exports.isAnonymous44(data))
    return;
  throw new ValidationError(exports.isAnonymous44.errors);
}
function assertAnonymous45Json(data) {
  if (exports.isAnonymous45Json(data))
    return;
  throw new ValidationError(exports.isAnonymous45Json.errors);
}
function assertAnonymous45(data) {
  if (exports.isAnonymous45(data))
    return;
  throw new ValidationError(exports.isAnonymous45.errors);
}
function assertAnonymous46Json(data) {
  if (exports.isAnonymous46Json(data))
    return;
  throw new ValidationError(exports.isAnonymous46Json.errors);
}
function assertAnonymous46(data) {
  if (exports.isAnonymous46(data))
    return;
  throw new ValidationError(exports.isAnonymous46.errors);
}
function assertGeneratePresignedUrlResponse(data) {
  if (exports.isGeneratePresignedUrlResponse(data))
    return;
  throw new ValidationError(exports.isGeneratePresignedUrlResponse.errors);
}
function assertGeneratePresignedUrlRequestPathParameters(data) {
  if (exports.isGeneratePresignedUrlRequestPathParameters(data))
    return;
  throw new ValidationError(exports.isGeneratePresignedUrlRequestPathParameters.errors);
}
function assertGeneratePresignedUrlRequestQueryStringParameters(data) {
  if (exports.isGeneratePresignedUrlRequestQueryStringParameters(data))
    return;
  throw new ValidationError(exports.isGeneratePresignedUrlRequestQueryStringParameters.errors);
}
function assertGeneratePresignedUrlRequest(data) {
  if (exports.isGeneratePresignedUrlRequest(data))
    return;
  throw new ValidationError(exports.isGeneratePresignedUrlRequest.errors);
}
function assertGetMetricsResponse(data) {
  if (exports.isGetMetricsResponse(data))
    return;
  throw new ValidationError(exports.isGetMetricsResponse.errors);
}
function assertGetMetricsRequest(data) {
  if (exports.isGetMetricsRequest(data))
    return;
  throw new ValidationError(exports.isGetMetricsRequest.errors);
}
function assertAnonymous47(data) {
  if (exports.isAnonymous47(data))
    return;
  throw new ValidationError(exports.isAnonymous47.errors);
}
function assertAnonymous48Json(data) {
  if (exports.isAnonymous48Json(data))
    return;
  throw new ValidationError(exports.isAnonymous48Json.errors);
}
function assertAnonymous48(data) {
  if (exports.isAnonymous48(data))
    return;
  throw new ValidationError(exports.isAnonymous48.errors);
}
function assertGetUserResponse(data) {
  if (exports.isGetUserResponse(data))
    return;
  throw new ValidationError(exports.isGetUserResponse.errors);
}
function assertGetUserRequest(data) {
  if (exports.isGetUserRequest(data))
    return;
  throw new ValidationError(exports.isGetUserRequest.errors);
}
function assertCreateUserResponse(data) {
  if (exports.isCreateUserResponse(data))
    return;
  throw new ValidationError(exports.isCreateUserResponse.errors);
}
function assertCreateUserRequestJson(data) {
  if (exports.isCreateUserRequestJson(data))
    return;
  throw new ValidationError(exports.isCreateUserRequestJson.errors);
}
function assertCreateUserRequest(data) {
  if (exports.isCreateUserRequest(data))
    return;
  throw new ValidationError(exports.isCreateUserRequest.errors);
}
function assertUpdateUserResponse(data) {
  if (exports.isUpdateUserResponse(data))
    return;
  throw new ValidationError(exports.isUpdateUserResponse.errors);
}
function assertUpdateUserRequestJson(data) {
  if (exports.isUpdateUserRequestJson(data))
    return;
  throw new ValidationError(exports.isUpdateUserRequestJson.errors);
}
function assertUpdateUserRequest(data) {
  if (exports.isUpdateUserRequest(data))
    return;
  throw new ValidationError(exports.isUpdateUserRequest.errors);
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
var isNumber = new RegExp(/^\d+$/);
var ValidationError = class extends Error {
  constructor(errors) {
    super();
    this.name = "ValidationError";
    this.errors = this.translate([...errors]);
  }
  translate(input) {
    const errors = [];
    for (const error of input) {
      const [_, rawField, nested] = error.instancePath.split("/");
      const field = rawField !== void 0 && rawField.length && !isNumber.test(rawField) ? { field: rawField } : {};
      if (nested || isNumber.test(rawField)) {
        const err = this.translate([{
          ...error,
          instancePath: "/"
        }]);
        errors.push({
          name: "Nested",
          ...field,
          index: parseInt(nested !== null && nested !== void 0 ? nested : rawField, 10),
          errors: err
        });
      } else if (error.keyword === "enum") {
        errors.push({
          name: "Enum",
          ...field
        });
      } else if (error.keyword === "required") {
        errors.push({
          name: "Required",
          field: error.params.missingProperty
        });
      } else if (error.keyword === "type") {
        errors.push({
          name: "TypeMismatch",
          expected: error.params.type,
          ...field
        });
      } else if (error.keyword === "additionalProperties") {
        errors.push({
          name: "AdditionalProperties",
          actual: [error.params.additionalProperty],
          expected: [],
          ...field
        });
      }
    }
    return errors;
  }
  toString() {
    return JSON.stringify(this.errors);
  }
};
exports.ValidationError = ValidationError;
exports.isFile = validate21;
function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.downloadUrl !== void 0) {
      if (typeof data.downloadUrl !== "string") {
        const err0 = { instancePath: instancePath + "/downloadUrl", schemaPath: "#/properties/downloadUrl/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.fileName !== void 0) {
      if (typeof data.fileName !== "string") {
        const err1 = { instancePath: instancePath + "/fileName", schemaPath: "#/properties/fileName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.fileSize !== void 0) {
      if (typeof data.fileSize !== "string") {
        const err2 = { instancePath: instancePath + "/fileSize", schemaPath: "#/properties/fileSize/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate21.errors = vErrors;
  return errors === 0;
}
exports.isJobAdvancedParameters = validate22;
function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (typeof data[key0] !== "string") {
        const err0 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate22.errors = vErrors;
  return errors === 0;
}
exports.isUser = validate23;
function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.userId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.email === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "email" }, message: "must have required property 'email'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.email !== void 0) {
      if (typeof data.email !== "string") {
        const err2 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.enableNotifications !== void 0) {
      if (typeof data.enableNotifications !== "boolean") {
        const err3 = { instancePath: instancePath + "/enableNotifications", schemaPath: "#/properties/enableNotifications/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.muid !== void 0) {
      if (typeof data.muid !== "string") {
        const err4 = { instancePath: instancePath + "/muid", schemaPath: "#/properties/muid/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err5 = { instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err6 = { instancePath: instancePath + "/userId", schemaPath: "#/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
  } else {
    const err7 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err7];
    } else {
      vErrors.push(err7);
    }
    errors++;
  }
  validate23.errors = vErrors;
  return errors === 0;
}
exports.isJobStatus = validate24;
var schema9 = { "enum": ["creating", "created", "queued", "running", "finished", "error", "submitted", "pending", "runnable", "starting", "succeeded", "failed"], "type": "string" };
function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "string" }, message: "must be string" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "creating" || data === "created" || data === "queued" || data === "running" || data === "finished" || data === "error" || data === "submitted" || data === "pending" || data === "runnable" || data === "starting" || data === "succeeded" || data === "failed")) {
    const err1 = { instancePath, schemaPath: "#/enum", keyword: "enum", params: { allowedValues: schema9.enum }, message: "must be equal to one of the allowed values" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate24.errors = vErrors;
  return errors === 0;
}
exports.isJob = validate25;
function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.status === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.createdAt !== void 0) {
      if (typeof data.createdAt !== "string") {
        const err2 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.message !== void 0) {
      if (typeof data.message !== "string") {
        const err3 = { instancePath: instancePath + "/message", schemaPath: "#/properties/message/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.status !== void 0) {
      if (!validate24(data.status, { instancePath: instancePath + "/status", parentData: data, parentDataProperty: "status", rootData })) {
        vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate27.errors = vErrors;
  return errors === 0;
}
function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.proteinSequence === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "proteinSequence" }, message: "must have required property 'proteinSequence'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.sequenceLength === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "sequenceLength" }, message: "must have required property 'sequenceLength'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.proteinName !== void 0) {
      if (typeof data.proteinName !== "string") {
        const err2 = { instancePath: instancePath + "/proteinName", schemaPath: "#/properties/proteinName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.proteinSequence !== void 0) {
      if (typeof data.proteinSequence !== "string") {
        const err3 = { instancePath: instancePath + "/proteinSequence", schemaPath: "#/properties/proteinSequence/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.sequenceLength !== void 0) {
      let data2 = data.sequenceLength;
      if (!(typeof data2 == "number" && isFinite(data2))) {
        const err4 = { instancePath: instancePath + "/sequenceLength", schemaPath: "#/properties/sequenceLength/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate31.errors = vErrors;
  return errors === 0;
}
function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.advancedParameters !== void 0) {
      if (!validate22(data.advancedParameters, { instancePath: instancePath + "/advancedParameters", parentData: data, parentDataProperty: "advancedParameters", rootData })) {
        vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
        errors = vErrors.length;
      }
    }
    if (data.auditTrail !== void 0) {
      let data1 = data.auditTrail;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate27(data1[i0], { instancePath: instancePath + "/auditTrail/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
            vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err0 = { instancePath: instancePath + "/auditTrail", schemaPath: "#/properties/auditTrail/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.changedAt !== void 0) {
      if (typeof data.changedAt !== "string") {
        const err1 = { instancePath: instancePath + "/changedAt", schemaPath: "#/properties/changedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.createdAt !== void 0) {
      if (typeof data.createdAt !== "string") {
        const err2 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.createdBy !== void 0) {
      if (!validate23(data.createdBy, { instancePath: instancePath + "/createdBy", parentData: data, parentDataProperty: "createdBy", rootData })) {
        vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
        errors = vErrors.length;
      }
    }
    if (data.error !== void 0) {
      if (typeof data.error !== "string") {
        const err3 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.inputFolder !== void 0) {
      if (typeof data.inputFolder !== "string") {
        const err4 = { instancePath: instancePath + "/inputFolder", schemaPath: "#/properties/inputFolder/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err5 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.jobName !== void 0) {
      if (typeof data.jobName !== "string") {
        const err6 = { instancePath: instancePath + "/jobName", schemaPath: "#/properties/jobName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.proteins !== void 0) {
      let data10 = data.proteins;
      if (Array.isArray(data10)) {
        const len1 = data10.length;
        for (let i1 = 0; i1 < len1; i1++) {
          if (!validate31(data10[i1], { instancePath: instancePath + "/proteins/" + i1, parentData: data10, parentDataProperty: i1, rootData })) {
            vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err7 = { instancePath: instancePath + "/proteins", schemaPath: "#/properties/proteins/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.queueTime !== void 0) {
      let data12 = data.queueTime;
      if (!(typeof data12 == "number" && isFinite(data12))) {
        const err8 = { instancePath: instancePath + "/queueTime", schemaPath: "#/properties/queueTime/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.resultFolder !== void 0) {
      if (typeof data.resultFolder !== "string") {
        const err9 = { instancePath: instancePath + "/resultFolder", schemaPath: "#/properties/resultFolder/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.runningTime !== void 0) {
      let data14 = data.runningTime;
      if (!(typeof data14 == "number" && isFinite(data14))) {
        const err10 = { instancePath: instancePath + "/runningTime", schemaPath: "#/properties/runningTime/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.status !== void 0) {
      if (!validate24(data.status, { instancePath: instancePath + "/status", parentData: data, parentDataProperty: "status", rootData })) {
        vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err11 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate25.errors = vErrors;
  return errors === 0;
}
exports.isJobStatusEntry = validate27;
exports.isProtein = validate31;
exports.isUserMetrics = validate34;
function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobsRunning === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobsRunning" }, message: "must have required property 'jobsRunning'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobsQueued === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobsQueued" }, message: "must have required property 'jobsQueued'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.submittedToday === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "submittedToday" }, message: "must have required property 'submittedToday'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.submittedThisMonth === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "submittedThisMonth" }, message: "must have required property 'submittedThisMonth'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.jobsQueued !== void 0) {
      let data0 = data.jobsQueued;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err4 = { instancePath: instancePath + "/jobsQueued", schemaPath: "#/properties/jobsQueued/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.jobsRunning !== void 0) {
      let data1 = data.jobsRunning;
      if (!(typeof data1 == "number" && isFinite(data1))) {
        const err5 = { instancePath: instancePath + "/jobsRunning", schemaPath: "#/properties/jobsRunning/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.submittedThisMonth !== void 0) {
      let data2 = data.submittedThisMonth;
      if (!(typeof data2 == "number" && isFinite(data2))) {
        const err6 = { instancePath: instancePath + "/submittedThisMonth", schemaPath: "#/properties/submittedThisMonth/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.submittedToday !== void 0) {
      let data3 = data.submittedToday;
      if (!(typeof data3 == "number" && isFinite(data3))) {
        const err7 = { instancePath: instancePath + "/submittedToday", schemaPath: "#/properties/submittedToday/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate34.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous1Json = validate35;
function validate35(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate35.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous1 = validate36;
var schema15 = { "type": "object", "description": "Bug created successfully", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [201] }, "json": { "$ref": "#/components/schemas/Anonymous1Json" } } };
function validate36(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 201)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema15.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate35(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate35.errors : vErrors.concat(validate35.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate36.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous2Json = validate38;
function validate38(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate38.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous2 = validate39;
var schema17 = { "type": "object", "description": "Bad request", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [400] }, "json": { "$ref": "#/components/schemas/Anonymous2Json" } } };
function validate39(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 400)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema17.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate38(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate39.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous3Json = validate41;
function validate41(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate41.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous3 = validate42;
var schema19 = { "type": "object", "description": "Method not allowed", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [405] }, "json": { "$ref": "#/components/schemas/Anonymous3Json" } } };
function validate42(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 405)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema19.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate41(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate41.errors : vErrors.concat(validate41.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate42.errors = vErrors;
  return errors === 0;
}
exports.isCreateBugResponse = validate44;
function validate44(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate36(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate36.errors : vErrors.concat(validate36.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate39(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate42(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate44.errors = vErrors;
  return errors === 0;
}
exports.isCreateBugRequestJson = validate48;
function validate48(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.title === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.stepsToReproduce === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "stepsToReproduce" }, message: "must have required property 'stepsToReproduce'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.attachment !== void 0) {
      if (!(typeof data.attachment === "string")) {
        const err2 = { instancePath: instancePath + "/attachment", schemaPath: "#/properties/attachment/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.attachmentName !== void 0) {
      if (typeof data.attachmentName !== "string") {
        const err3 = { instancePath: instancePath + "/attachmentName", schemaPath: "#/properties/attachmentName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.expectedResult !== void 0) {
      if (typeof data.expectedResult !== "string") {
        const err4 = { instancePath: instancePath + "/expectedResult", schemaPath: "#/properties/expectedResult/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.stepsToReproduce !== void 0) {
      if (typeof data.stepsToReproduce !== "string") {
        const err5 = { instancePath: instancePath + "/stepsToReproduce", schemaPath: "#/properties/stepsToReproduce/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.systemInformation !== void 0) {
      if (typeof data.systemInformation !== "string") {
        const err6 = { instancePath: instancePath + "/systemInformation", schemaPath: "#/properties/systemInformation/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err7 = { instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate48.errors = vErrors;
  return errors === 0;
}
exports.isCreateBugRequest = validate49;
function validate49(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.json === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json !== void 0) {
      if (!validate48(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate49.errors = vErrors;
  return errors === 0;
}
exports.isCreateFeedbackResponseJson = validate51;
function validate51(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate51.errors = vErrors;
  return errors === 0;
}
exports.isCreateFeedbackResponse = validate52;
var schema24 = { "type": "object", "description": "Feedback successfully posted.", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [201] }, "json": { "$ref": "#/components/schemas/CreateFeedbackResponseJson" } } };
function validate52(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 201)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema24.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate51(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate51.errors : vErrors.concat(validate51.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate52.errors = vErrors;
  return errors === 0;
}
exports.isCreateFeedbackRequestJson = validate54;
function validate54(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.subject === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "subject" }, message: "must have required property 'subject'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.message === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "message" }, message: "must have required property 'message'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.message !== void 0) {
      if (typeof data.message !== "string") {
        const err2 = { instancePath: instancePath + "/message", schemaPath: "#/properties/message/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.subject !== void 0) {
      if (typeof data.subject !== "string") {
        const err3 = { instancePath: instancePath + "/subject", schemaPath: "#/properties/subject/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate54.errors = vErrors;
  return errors === 0;
}
exports.isCreateFeedbackRequest = validate55;
function validate55(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.json === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json !== void 0) {
      if (!validate54(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate55.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous4 = validate57;
var schema27 = { "type": "object", "description": "Success", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "items": { "$ref": "#/components/schemas/Job" }, "type": "array" } } };
function validate57(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema27.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      let data1 = data.json;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate25(data1[i0], { instancePath: instancePath + "/json/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
            vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err4 = { instancePath: instancePath + "/json", schemaPath: "#/properties/json/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate57.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous5Json = validate59;
function validate59(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate59.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous5 = validate60;
var schema29 = { "type": "object", "description": "Job not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous5Json" } } };
function validate60(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema29.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate59(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate59.errors : vErrors.concat(validate59.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate60.errors = vErrors;
  return errors === 0;
}
exports.isListJobsResponse = validate62;
function validate62(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate57(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate60(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate62.errors = vErrors;
  return errors === 0;
}
exports.isListJobsRequest = validate65;
function validate65(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate65.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous6 = validate66;
var schema32 = { "type": "object", "description": "item created", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [201] }, "json": { "$ref": "#/components/schemas/Job" } } };
function validate66(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 201)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema32.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate25(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate66.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous9Json = validate68;
function validate68(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate68.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous9 = validate69;
var schema34 = { "type": "object", "description": "invalid input, object invalid", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [400] }, "json": { "$ref": "#/components/schemas/Anonymous9Json" } } };
function validate69(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 400)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema34.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate68(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate69.errors = vErrors;
  return errors === 0;
}
exports.isCreateJobResponse = validate71;
function validate71(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate66(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate66.errors : vErrors.concat(validate66.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate69(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate71.errors = vErrors;
  return errors === 0;
}
exports.isCreateJobRequestJson = validate74;
function validate74(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobName === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobName" }, message: "must have required property 'jobName'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobName !== void 0) {
      if (typeof data.jobName !== "string") {
        const err1 = { instancePath: instancePath + "/jobName", schemaPath: "#/properties/jobName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate74.errors = vErrors;
  return errors === 0;
}
exports.isCreateJobRequest = validate75;
function validate75(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.json === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json !== void 0) {
      if (!validate74(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate75.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous10Json = validate77;
function validate77(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate77.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous10 = validate78;
var schema39 = { "type": "object", "description": "Successfully deleted", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [204] }, "json": { "$ref": "#/components/schemas/Anonymous10Json" } } };
function validate78(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 204)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema39.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate77(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate77.errors : vErrors.concat(validate77.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate78.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous11Json = validate80;
function validate80(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate80.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous11 = validate81;
var schema41 = { "type": "object", "description": "no job for provided id", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous11Json" } } };
function validate81(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema41.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate80(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate80.errors : vErrors.concat(validate80.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate81.errors = vErrors;
  return errors === 0;
}
exports.isDeleteJobResponse = validate83;
function validate83(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate78(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate78.errors : vErrors.concat(validate78.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate81(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate81.errors : vErrors.concat(validate81.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate83.errors = vErrors;
  return errors === 0;
}
exports.isDeleteJobRequestPathParameters = validate86;
function validate86(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate86.errors = vErrors;
  return errors === 0;
}
exports.isDeleteJobRequest = validate87;
function validate87(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate86(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate86.errors : vErrors.concat(validate86.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate87.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous12 = validate89;
var schema45 = { "type": "object", "description": "Job for provided id", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "$ref": "#/components/schemas/Job" } } };
function validate89(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema45.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate25(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate89.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous15Json = validate91;
function validate91(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate91.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous15 = validate92;
var schema47 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous15Json" } } };
function validate92(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema47.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate91(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate91.errors : vErrors.concat(validate91.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate92.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous16Json = validate94;
function validate94(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate94.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous16 = validate95;
var schema49 = { "type": "object", "description": "no job for provided id", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous16Json" } } };
function validate95(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema49.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate94(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate94.errors : vErrors.concat(validate94.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate95.errors = vErrors;
  return errors === 0;
}
exports.isGetJobByIdResponse = validate97;
function validate97(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate89(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate89.errors : vErrors.concat(validate89.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate92(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate92.errors : vErrors.concat(validate92.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate95(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate95.errors : vErrors.concat(validate95.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate97.errors = vErrors;
  return errors === 0;
}
exports.isGetJobByIdRequestPathParameters = validate101;
function validate101(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate101.errors = vErrors;
  return errors === 0;
}
exports.isGetJobByIdRequest = validate102;
function validate102(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate101(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate101.errors : vErrors.concat(validate101.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate102.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous17 = validate104;
var schema53 = { "type": "object", "description": "List of Recommendations for next steps of a Project", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "items": { "$ref": "#/components/schemas/File" }, "type": "array" } } };
function validate104(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema53.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      let data1 = data.json;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate21(data1[i0], { instancePath: instancePath + "/json/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
            vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err4 = { instancePath: instancePath + "/json", schemaPath: "#/properties/json/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate104.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous18Json = validate106;
function validate106(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate106.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous18 = validate107;
var schema55 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous18Json" } } };
function validate107(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema55.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate106(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate106.errors : vErrors.concat(validate106.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate107.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous19Json = validate109;
function validate109(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate109.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous19 = validate110;
var schema57 = { "type": "object", "description": "job not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous19Json" } } };
function validate110(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema57.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate109(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate109.errors : vErrors.concat(validate109.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate110.errors = vErrors;
  return errors === 0;
}
exports.isListInputResponse = validate112;
function validate112(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate104(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate104.errors : vErrors.concat(validate104.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate107(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate107.errors : vErrors.concat(validate107.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate110(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate110.errors : vErrors.concat(validate110.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate112.errors = vErrors;
  return errors === 0;
}
exports.isListInputRequestPathParameters = validate116;
function validate116(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate116.errors = vErrors;
  return errors === 0;
}
exports.isListInputRequestQueryStringParameters = validate117;
var schema60 = { "type": "object", "required": [], "properties": { "fileType": { "enum": ["sequence", "template"], "type": "string", "description": "Specify whether it's an sequence or a template" } }, "nullable": true };
function validate117(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data)) && data !== null) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.fileType !== void 0) {
      let data0 = data.fileType;
      if (typeof data0 !== "string") {
        const err1 = { instancePath: instancePath + "/fileType", schemaPath: "#/properties/fileType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === "sequence" || data0 === "template")) {
        const err2 = { instancePath: instancePath + "/fileType", schemaPath: "#/properties/fileType/enum", keyword: "enum", params: { allowedValues: schema60.properties.fileType.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  }
  validate117.errors = vErrors;
  return errors === 0;
}
exports.isListInputRequest = validate118;
function validate118(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate116(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate116.errors : vErrors.concat(validate116.errors);
        errors = vErrors.length;
      }
    }
    if (data.queryStringParameters !== void 0) {
      if (!validate117(data.queryStringParameters, { instancePath: instancePath + "/queryStringParameters", parentData: data, parentDataProperty: "queryStringParameters", rootData })) {
        vErrors = vErrors === null ? validate117.errors : vErrors.concat(validate117.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate118.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous20 = validate121;
var schema62 = { "type": "object", "description": "Updated job", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "$ref": "#/components/schemas/Job" } } };
function validate121(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema62.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate25(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate121.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous23Json = validate123;
function validate123(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.message !== void 0) {
      if (typeof data.message !== "string") {
        const err0 = { instancePath: instancePath + "/message", schemaPath: "#/properties/message/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate123.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous23 = validate124;
var schema64 = { "type": "object", "description": "fasta file not valid", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [400] }, "json": { "$ref": "#/components/schemas/Anonymous23Json" } } };
function validate124(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 400)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema64.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate123(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate123.errors : vErrors.concat(validate123.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate124.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous24Json = validate126;
function validate126(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate126.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous24 = validate127;
var schema66 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous24Json" } } };
function validate127(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema66.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate126(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate126.errors : vErrors.concat(validate126.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate127.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous25Json = validate129;
function validate129(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate129.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous25 = validate130;
var schema68 = { "type": "object", "description": "job not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous25Json" } } };
function validate130(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema68.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate129(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate129.errors : vErrors.concat(validate129.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate130.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous26Json = validate132;
function validate132(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate132.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous26 = validate133;
var schema70 = { "type": "object", "description": "fasta file too large", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [413] }, "json": { "$ref": "#/components/schemas/Anonymous26Json" } } };
function validate133(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 413)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema70.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate132(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate132.errors : vErrors.concat(validate132.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate133.errors = vErrors;
  return errors === 0;
}
exports.isSubmitInputResponse = validate135;
function validate135(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate121(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate121.errors : vErrors.concat(validate121.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate124(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate124.errors : vErrors.concat(validate124.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate127(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate127.errors : vErrors.concat(validate127.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs5 = errors;
      if (!validate130(data, { instancePath, parentData, parentDataProperty, rootData })) {
        vErrors = vErrors === null ? validate130.errors : vErrors.concat(validate130.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs5 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs6 = errors;
        if (!validate133(data, { instancePath, parentData, parentDataProperty, rootData })) {
          vErrors = vErrors === null ? validate133.errors : vErrors.concat(validate133.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs6 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
        }
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate135.errors = vErrors;
  return errors === 0;
}
exports.isSubmitInputRequestPathParameters = validate141;
function validate141(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate141.errors = vErrors;
  return errors === 0;
}
exports.isSubmitInputRequestQueryStringParameters = validate142;
var schema73 = { "type": "object", "required": [], "properties": { "fileType": { "enum": ["sequence", "template"], "type": "string", "description": "Specify whether it's an sequence or a template" } }, "nullable": true };
function validate142(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data)) && data !== null) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.fileType !== void 0) {
      let data0 = data.fileType;
      if (typeof data0 !== "string") {
        const err1 = { instancePath: instancePath + "/fileType", schemaPath: "#/properties/fileType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === "sequence" || data0 === "template")) {
        const err2 = { instancePath: instancePath + "/fileType", schemaPath: "#/properties/fileType/enum", keyword: "enum", params: { allowedValues: schema73.properties.fileType.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  }
  validate142.errors = vErrors;
  return errors === 0;
}
exports.isSubmitInputRequest = validate143;
function validate143(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate141(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate141.errors : vErrors.concat(validate141.errors);
        errors = vErrors.length;
      }
    }
    if (data.queryStringParameters !== void 0) {
      if (!validate142(data.queryStringParameters, { instancePath: instancePath + "/queryStringParameters", parentData: data, parentDataProperty: "queryStringParameters", rootData })) {
        vErrors = vErrors === null ? validate142.errors : vErrors.concat(validate142.errors);
        errors = vErrors.length;
      }
    }
    if (data.json !== void 0) {
      let data2 = data.json;
      if (Array.isArray(data2)) {
        const len0 = data2.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate21(data2[i0], { instancePath: instancePath + "/json/" + i0, parentData: data2, parentDataProperty: i0, rootData })) {
            vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err2 = { instancePath: instancePath + "/json", schemaPath: "#/properties/json/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate143.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous27 = validate147;
var schema75 = { "type": "object", "description": "Results for a job", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "items": { "$ref": "#/components/schemas/File" }, "type": "array" } } };
function validate147(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema75.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      let data1 = data.json;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate21(data1[i0], { instancePath: instancePath + "/json/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
            vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err4 = { instancePath: instancePath + "/json", schemaPath: "#/properties/json/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate147.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous28Json = validate149;
function validate149(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate149.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous28 = validate150;
var schema77 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous28Json" } } };
function validate150(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema77.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate149(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate149.errors : vErrors.concat(validate149.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate150.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous29Json = validate152;
function validate152(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate152.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous29 = validate153;
var schema79 = { "type": "object", "description": "job not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous29Json" } } };
function validate153(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema79.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate152(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate152.errors : vErrors.concat(validate152.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate153.errors = vErrors;
  return errors === 0;
}
exports.isListResultResponse = validate155;
function validate155(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate147(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate147.errors : vErrors.concat(validate147.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate150(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate150.errors : vErrors.concat(validate150.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate153(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate153.errors : vErrors.concat(validate153.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate155.errors = vErrors;
  return errors === 0;
}
exports.isListResultRequestPathParameters = validate159;
function validate159(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate159.errors = vErrors;
  return errors === 0;
}
exports.isListResultRequest = validate160;
function validate160(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate159(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate159.errors : vErrors.concat(validate159.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate160.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous30 = validate162;
var schema83 = { "type": "object", "description": "Results for a job", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "$ref": "#/components/schemas/File" } } };
function validate162(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema83.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate21(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate162.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous31Json = validate164;
function validate164(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate164.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous31 = validate165;
var schema85 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous31Json" } } };
function validate165(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema85.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate164(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate164.errors : vErrors.concat(validate164.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate165.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous32Json = validate167;
function validate167(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate167.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous32 = validate168;
var schema87 = { "type": "object", "description": "job not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous32Json" } } };
function validate168(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema87.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate167(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate167.errors : vErrors.concat(validate167.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate168.errors = vErrors;
  return errors === 0;
}
exports.isGetResultArchiveResponse = validate170;
function validate170(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate162(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate165(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate165.errors : vErrors.concat(validate165.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate168(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate168.errors : vErrors.concat(validate168.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate170.errors = vErrors;
  return errors === 0;
}
exports.isGetResultArchiveRequestPathParameters = validate174;
function validate174(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate174.errors = vErrors;
  return errors === 0;
}
exports.isGetResultArchiveRequest = validate175;
function validate175(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate174(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate174.errors : vErrors.concat(validate174.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate175.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous33 = validate177;
var schema91 = { "type": "object", "description": "Results for a job", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "items": { "$ref": "#/components/schemas/File" }, "type": "array" } } };
function validate177(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema91.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      let data1 = data.json;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate21(data1[i0], { instancePath: instancePath + "/json/" + i0, parentData: data1, parentDataProperty: i0, rootData })) {
            vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err4 = { instancePath: instancePath + "/json", schemaPath: "#/properties/json/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate177.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous34Json = validate179;
function validate179(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate179.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous34 = validate180;
var schema93 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous34Json" } } };
function validate180(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema93.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate179(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate179.errors : vErrors.concat(validate179.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate180.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous35Json = validate182;
function validate182(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate182.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous35 = validate183;
var schema95 = { "type": "object", "description": "job not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous35Json" } } };
function validate183(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema95.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate182(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate182.errors : vErrors.concat(validate182.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate183.errors = vErrors;
  return errors === 0;
}
exports.isListResultImagesResponse = validate185;
function validate185(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate177(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate177.errors : vErrors.concat(validate177.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate180(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate180.errors : vErrors.concat(validate180.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate183(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate183.errors : vErrors.concat(validate183.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate185.errors = vErrors;
  return errors === 0;
}
exports.isListResultImagesRequestPathParameters = validate189;
function validate189(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate189.errors = vErrors;
  return errors === 0;
}
exports.isListResultImagesRequest = validate190;
function validate190(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate189(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate189.errors : vErrors.concat(validate189.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate190.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous36 = validate192;
var schema99 = { "type": "object", "description": "Updated job", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [201] }, "json": { "$ref": "#/components/schemas/Job" } } };
function validate192(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 201)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema99.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate25(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate192.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous39Json = validate194;
function validate194(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate194.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous39 = validate195;
var schema101 = { "type": "object", "description": "Validation error", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [400] }, "json": { "$ref": "#/components/schemas/Anonymous39Json" } } };
function validate195(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 400)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema101.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate194(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate194.errors : vErrors.concat(validate194.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate195.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous40Json = validate197;
function validate197(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate197.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous40 = validate198;
var schema103 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous40Json" } } };
function validate198(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema103.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate197(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate197.errors : vErrors.concat(validate197.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate198.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous41Json = validate200;
function validate200(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate200.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous41 = validate201;
var schema105 = { "type": "object", "description": "Job not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous41Json" } } };
function validate201(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema105.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate200(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate200.errors : vErrors.concat(validate200.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate201.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous42Json = validate203;
function validate203(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate203.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous42 = validate204;
var schema107 = { "type": "object", "description": "File limit reached", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [413] }, "json": { "$ref": "#/components/schemas/Anonymous42Json" } } };
function validate204(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 413)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema107.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate203(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate203.errors : vErrors.concat(validate203.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate204.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous43Json = validate206;
function validate206(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate206.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous43 = validate207;
var schema109 = { "type": "object", "description": "Internal Server Error", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [500] }, "json": { "$ref": "#/components/schemas/Anonymous43Json" } } };
function validate207(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 500)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema109.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate206(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate206.errors : vErrors.concat(validate206.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate207.errors = vErrors;
  return errors === 0;
}
exports.isSubmitJobResponse = validate209;
function validate209(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate192(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate192.errors : vErrors.concat(validate192.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate195(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate195.errors : vErrors.concat(validate195.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate198(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate198.errors : vErrors.concat(validate198.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs5 = errors;
      if (!validate201(data, { instancePath, parentData, parentDataProperty, rootData })) {
        vErrors = vErrors === null ? validate201.errors : vErrors.concat(validate201.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs5 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs6 = errors;
        if (!validate204(data, { instancePath, parentData, parentDataProperty, rootData })) {
          vErrors = vErrors === null ? validate204.errors : vErrors.concat(validate204.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs6 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
          const _errs7 = errors;
          if (!validate207(data, { instancePath, parentData, parentDataProperty, rootData })) {
            vErrors = vErrors === null ? validate207.errors : vErrors.concat(validate207.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs7 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate209.errors = vErrors;
  return errors === 0;
}
exports.isSubmitJobRequestPathParameters = validate216;
function validate216(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate216.errors = vErrors;
  return errors === 0;
}
exports.isSubmitJobRequestJsonAdvancedParameters = validate217;
function validate217(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (typeof data[key0] !== "string") {
        const err0 = { instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/additionalProperties/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate217.errors = vErrors;
  return errors === 0;
}
exports.isSubmitJobRequestJsonUseSpotInstance = validate218;
function validate218(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.cpu !== void 0) {
      if (typeof data.cpu !== "boolean") {
        const err0 = { instancePath: instancePath + "/cpu", schemaPath: "#/properties/cpu/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.gpu !== void 0) {
      if (typeof data.gpu !== "boolean") {
        const err1 = { instancePath: instancePath + "/gpu", schemaPath: "#/properties/gpu/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate218.errors = vErrors;
  return errors === 0;
}
exports.isSubmitJobRequestJson = validate219;
function validate219(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.advancedParameters !== void 0) {
      if (!validate217(data.advancedParameters, { instancePath: instancePath + "/advancedParameters", parentData: data, parentDataProperty: "advancedParameters", rootData })) {
        vErrors = vErrors === null ? validate217.errors : vErrors.concat(validate217.errors);
        errors = vErrors.length;
      }
    }
    if (data.useSpotInstance !== void 0) {
      if (!validate218(data.useSpotInstance, { instancePath: instancePath + "/useSpotInstance", parentData: data, parentDataProperty: "useSpotInstance", rootData })) {
        vErrors = vErrors === null ? validate218.errors : vErrors.concat(validate218.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate219.errors = vErrors;
  return errors === 0;
}
exports.isSubmitJobRequest = validate222;
function validate222(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate216(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate216.errors : vErrors.concat(validate216.errors);
        errors = vErrors.length;
      }
    }
    if (data.json !== void 0) {
      if (!validate219(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate219.errors : vErrors.concat(validate219.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate222.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous44Json = validate225;
function validate225(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.url === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.expires !== void 0) {
      if (typeof data.expires !== "string") {
        const err1 = { instancePath: instancePath + "/expires", schemaPath: "#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err2 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate225.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous44 = validate226;
var schema117 = { "type": "object", "description": "Presigned Url to upload file", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "$ref": "#/components/schemas/Anonymous44Json" } } };
function validate226(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema117.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate225(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate225.errors : vErrors.concat(validate225.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate226.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous45Json = validate228;
function validate228(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate228.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous45 = validate229;
var schema119 = { "type": "object", "description": "User is not authorized to view job", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [403] }, "json": { "$ref": "#/components/schemas/Anonymous45Json" } } };
function validate229(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 403)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema119.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate228(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate228.errors : vErrors.concat(validate228.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate229.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous46Json = validate231;
function validate231(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate231.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous46 = validate232;
var schema121 = { "type": "object", "description": "no job for provided id", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous46Json" } } };
function validate232(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema121.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate231(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate231.errors : vErrors.concat(validate231.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate232.errors = vErrors;
  return errors === 0;
}
exports.isGeneratePresignedUrlResponse = validate234;
function validate234(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate226(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate226.errors : vErrors.concat(validate226.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate229(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate229.errors : vErrors.concat(validate229.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!validate232(data, { instancePath, parentData, parentDataProperty, rootData })) {
      vErrors = vErrors === null ? validate232.errors : vErrors.concat(validate232.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate234.errors = vErrors;
  return errors === 0;
}
exports.isGeneratePresignedUrlRequestPathParameters = validate238;
function validate238(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.jobId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "jobId" }, message: "must have required property 'jobId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.jobId !== void 0) {
      if (typeof data.jobId !== "string") {
        const err1 = { instancePath: instancePath + "/jobId", schemaPath: "#/properties/jobId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate238.errors = vErrors;
  return errors === 0;
}
exports.isGeneratePresignedUrlRequestQueryStringParameters = validate239;
var schema124 = { "type": "object", "required": ["fileName"], "properties": { "fileName": { "example": "input.fasta", "type": "string", "description": "Name of the input file that shall be uploaded" }, "fileType": { "enum": ["sequence", "template"], "type": "string", "description": "Specify whether it's an sequence or a template" } }, "nullable": false };
function validate239(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.fileName === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "fileName" }, message: "must have required property 'fileName'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.fileName !== void 0) {
      if (typeof data.fileName !== "string") {
        const err1 = { instancePath: instancePath + "/fileName", schemaPath: "#/properties/fileName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.fileType !== void 0) {
      let data1 = data.fileType;
      if (typeof data1 !== "string") {
        const err2 = { instancePath: instancePath + "/fileType", schemaPath: "#/properties/fileType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data1 === "sequence" || data1 === "template")) {
        const err3 = { instancePath: instancePath + "/fileType", schemaPath: "#/properties/fileType/enum", keyword: "enum", params: { allowedValues: schema124.properties.fileType.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate239.errors = vErrors;
  return errors === 0;
}
exports.isGeneratePresignedUrlRequest = validate240;
function validate240(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.pathParameters === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "pathParameters" }, message: "must have required property 'pathParameters'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.queryStringParameters === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "queryStringParameters" }, message: "must have required property 'queryStringParameters'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.pathParameters !== void 0) {
      if (!validate238(data.pathParameters, { instancePath: instancePath + "/pathParameters", parentData: data, parentDataProperty: "pathParameters", rootData })) {
        vErrors = vErrors === null ? validate238.errors : vErrors.concat(validate238.errors);
        errors = vErrors.length;
      }
    }
    if (data.queryStringParameters !== void 0) {
      if (!validate239(data.queryStringParameters, { instancePath: instancePath + "/queryStringParameters", parentData: data, parentDataProperty: "queryStringParameters", rootData })) {
        vErrors = vErrors === null ? validate239.errors : vErrors.concat(validate239.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate240.errors = vErrors;
  return errors === 0;
}
exports.isGetMetricsResponse = validate243;
var schema126 = { "type": "object", "description": "Success", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "$ref": "#/components/schemas/UserMetrics" } } };
function validate243(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema126.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate34(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate34.errors : vErrors.concat(validate34.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate243.errors = vErrors;
  return errors === 0;
}
exports.isGetMetricsRequest = validate245;
function validate245(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate245.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous47 = validate246;
var schema128 = { "type": "object", "description": "Success", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "$ref": "#/components/schemas/User" } } };
function validate246(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema128.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate23(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate246.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous48Json = validate248;
function validate248(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate248.errors = vErrors;
  return errors === 0;
}
exports.isAnonymous48 = validate249;
var schema130 = { "type": "object", "description": "User not found", "required": ["statusCode"], "properties": { "statusCode": { "type": "number", "enum": [404] }, "json": { "$ref": "#/components/schemas/Anonymous48Json" } } };
function validate249(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 404)) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema130.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate248(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate248.errors : vErrors.concat(validate248.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate249.errors = vErrors;
  return errors === 0;
}
exports.isGetUserResponse = validate251;
function validate251(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!validate246(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate246.errors : vErrors.concat(validate246.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!validate249(data, { instancePath, parentData, parentDataProperty, rootData })) {
    vErrors = vErrors === null ? validate249.errors : vErrors.concat(validate249.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
  }
  if (!valid0) {
    const err1 = { instancePath, schemaPath: "#/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate251.errors = vErrors;
  return errors === 0;
}
exports.isGetUserRequest = validate254;
function validate254(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == "object" && !Array.isArray(data))) {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate254.errors = vErrors;
  return errors === 0;
}
exports.isCreateUserResponse = validate255;
var schema133 = { "type": "object", "description": "Success", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [201] }, "json": { "$ref": "#/components/schemas/User" } } };
function validate255(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 201)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema133.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate23(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate255.errors = vErrors;
  return errors === 0;
}
exports.isCreateUserRequestJson = validate257;
function validate257(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.muid !== void 0) {
      if (typeof data.muid !== "string") {
        const err0 = { instancePath: instancePath + "/muid", schemaPath: "#/properties/muid/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err1 = { instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate257.errors = vErrors;
  return errors === 0;
}
exports.isCreateUserRequest = validate258;
function validate258(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.json === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json !== void 0) {
      if (!validate257(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate257.errors : vErrors.concat(validate257.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate258.errors = vErrors;
  return errors === 0;
}
exports.isUpdateUserResponse = validate260;
var schema136 = { "type": "object", "description": "Success", "required": ["statusCode", "json"], "properties": { "statusCode": { "type": "number", "enum": [200] }, "json": { "$ref": "#/components/schemas/User" } } };
function validate260(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.statusCode === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "statusCode" }, message: "must have required property 'statusCode'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.statusCode !== void 0) {
      let data0 = data.statusCode;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === 200)) {
        const err3 = { instancePath: instancePath + "/statusCode", schemaPath: "#/properties/statusCode/enum", keyword: "enum", params: { allowedValues: schema136.properties.statusCode.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.json !== void 0) {
      if (!validate23(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate260.errors = vErrors;
  return errors === 0;
}
exports.isUpdateUserRequestJson = validate262;
function validate262(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.enableNotifications !== void 0) {
      if (typeof data.enableNotifications !== "boolean") {
        const err0 = { instancePath: instancePath + "/enableNotifications", schemaPath: "#/properties/enableNotifications/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.muid !== void 0) {
      if (typeof data.muid !== "string") {
        const err1 = { instancePath: instancePath + "/muid", schemaPath: "#/properties/muid/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err2 = { instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate262.errors = vErrors;
  return errors === 0;
}
exports.isUpdateUserRequest = validate263;
function validate263(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.json === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "json" }, message: "must have required property 'json'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.json !== void 0) {
      if (!validate262(data.json, { instancePath: instancePath + "/json", parentData: data, parentDataProperty: "json", rootData })) {
        vErrors = vErrors === null ? validate262.errors : vErrors.concat(validate262.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate263.errors = vErrors;
  return errors === 0;
}
var validators = {
  CreateBug: {
    isRequest: exports.isCreateBugRequest,
    isResponse: exports.isCreateBugResponse,
    assertRequest: assertCreateBugRequest,
    assertResponse: assertCreateBugResponse
  },
  CreateFeedback: {
    isRequest: exports.isCreateFeedbackRequest,
    isResponse: exports.isCreateFeedbackResponse,
    assertRequest: assertCreateFeedbackRequest,
    assertResponse: assertCreateFeedbackResponse
  },
  ListJobs: {
    isRequest: exports.isListJobsRequest,
    isResponse: exports.isListJobsResponse,
    assertRequest: assertListJobsRequest,
    assertResponse: assertListJobsResponse
  },
  CreateJob: {
    isRequest: exports.isCreateJobRequest,
    isResponse: exports.isCreateJobResponse,
    assertRequest: assertCreateJobRequest,
    assertResponse: assertCreateJobResponse
  },
  DeleteJob: {
    isRequest: exports.isDeleteJobRequest,
    isResponse: exports.isDeleteJobResponse,
    assertRequest: assertDeleteJobRequest,
    assertResponse: assertDeleteJobResponse
  },
  GetJobById: {
    isRequest: exports.isGetJobByIdRequest,
    isResponse: exports.isGetJobByIdResponse,
    assertRequest: assertGetJobByIdRequest,
    assertResponse: assertGetJobByIdResponse
  },
  ListInput: {
    isRequest: exports.isListInputRequest,
    isResponse: exports.isListInputResponse,
    assertRequest: assertListInputRequest,
    assertResponse: assertListInputResponse
  },
  SubmitInput: {
    isRequest: exports.isSubmitInputRequest,
    isResponse: exports.isSubmitInputResponse,
    assertRequest: assertSubmitInputRequest,
    assertResponse: assertSubmitInputResponse
  },
  ListResult: {
    isRequest: exports.isListResultRequest,
    isResponse: exports.isListResultResponse,
    assertRequest: assertListResultRequest,
    assertResponse: assertListResultResponse
  },
  GetResultArchive: {
    isRequest: exports.isGetResultArchiveRequest,
    isResponse: exports.isGetResultArchiveResponse,
    assertRequest: assertGetResultArchiveRequest,
    assertResponse: assertGetResultArchiveResponse
  },
  ListResultImages: {
    isRequest: exports.isListResultImagesRequest,
    isResponse: exports.isListResultImagesResponse,
    assertRequest: assertListResultImagesRequest,
    assertResponse: assertListResultImagesResponse
  },
  SubmitJob: {
    isRequest: exports.isSubmitJobRequest,
    isResponse: exports.isSubmitJobResponse,
    assertRequest: assertSubmitJobRequest,
    assertResponse: assertSubmitJobResponse
  },
  GeneratePresignedUrl: {
    isRequest: exports.isGeneratePresignedUrlRequest,
    isResponse: exports.isGeneratePresignedUrlResponse,
    assertRequest: assertGeneratePresignedUrlRequest,
    assertResponse: assertGeneratePresignedUrlResponse
  },
  GetMetrics: {
    isRequest: exports.isGetMetricsRequest,
    isResponse: exports.isGetMetricsResponse,
    assertRequest: assertGetMetricsRequest,
    assertResponse: assertGetMetricsResponse
  },
  GetUser: {
    isRequest: exports.isGetUserRequest,
    isResponse: exports.isGetUserResponse,
    assertRequest: assertGetUserRequest,
    assertResponse: assertGetUserResponse
  },
  CreateUser: {
    isRequest: exports.isCreateUserRequest,
    isResponse: exports.isCreateUserResponse,
    assertRequest: assertCreateUserRequest,
    assertResponse: assertCreateUserResponse
  },
  UpdateUser: {
    isRequest: exports.isUpdateUserRequest,
    isResponse: exports.isUpdateUserResponse,
    assertRequest: assertUpdateUserRequest,
    assertResponse: assertUpdateUserResponse
  }
};
var routes = {
  "POST /bug": "CreateBug",
  "POST /feedback": "CreateFeedback",
  "GET /job": "ListJobs",
  "POST /job": "CreateJob",
  "DELETE /job/{jobId}": "DeleteJob",
  "GET /job/{jobId}": "GetJobById",
  "GET /job/{jobId}/input": "ListInput",
  "POST /job/{jobId}/input": "SubmitInput",
  "GET /job/{jobId}/result": "ListResult",
  "GET /job/{jobId}/result-archive": "GetResultArchive",
  "GET /job/{jobId}/result-images": "ListResultImages",
  "POST /job/{jobId}/submit": "SubmitJob",
  "GET /job/{jobId}/upload": "GeneratePresignedUrl",
  "GET /metric": "GetMetrics",
  "GET /user": "GetUser",
  "POST /user": "CreateUser",
  "PUT /user": "UpdateUser"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  JobStatus,
  assertAnonymous1,
  assertAnonymous10,
  assertAnonymous10Json,
  assertAnonymous11,
  assertAnonymous11Json,
  assertAnonymous12,
  assertAnonymous15,
  assertAnonymous15Json,
  assertAnonymous16,
  assertAnonymous16Json,
  assertAnonymous17,
  assertAnonymous18,
  assertAnonymous18Json,
  assertAnonymous19,
  assertAnonymous19Json,
  assertAnonymous1Json,
  assertAnonymous2,
  assertAnonymous20,
  assertAnonymous23,
  assertAnonymous23Json,
  assertAnonymous24,
  assertAnonymous24Json,
  assertAnonymous25,
  assertAnonymous25Json,
  assertAnonymous26,
  assertAnonymous26Json,
  assertAnonymous27,
  assertAnonymous28,
  assertAnonymous28Json,
  assertAnonymous29,
  assertAnonymous29Json,
  assertAnonymous2Json,
  assertAnonymous3,
  assertAnonymous30,
  assertAnonymous31,
  assertAnonymous31Json,
  assertAnonymous32,
  assertAnonymous32Json,
  assertAnonymous33,
  assertAnonymous34,
  assertAnonymous34Json,
  assertAnonymous35,
  assertAnonymous35Json,
  assertAnonymous36,
  assertAnonymous39,
  assertAnonymous39Json,
  assertAnonymous3Json,
  assertAnonymous4,
  assertAnonymous40,
  assertAnonymous40Json,
  assertAnonymous41,
  assertAnonymous41Json,
  assertAnonymous42,
  assertAnonymous42Json,
  assertAnonymous43,
  assertAnonymous43Json,
  assertAnonymous44,
  assertAnonymous44Json,
  assertAnonymous45,
  assertAnonymous45Json,
  assertAnonymous46,
  assertAnonymous46Json,
  assertAnonymous47,
  assertAnonymous48,
  assertAnonymous48Json,
  assertAnonymous5,
  assertAnonymous5Json,
  assertAnonymous6,
  assertAnonymous9,
  assertAnonymous9Json,
  assertCreateBugRequest,
  assertCreateBugRequestJson,
  assertCreateBugResponse,
  assertCreateFeedbackRequest,
  assertCreateFeedbackRequestJson,
  assertCreateFeedbackResponse,
  assertCreateFeedbackResponseJson,
  assertCreateJobRequest,
  assertCreateJobRequestJson,
  assertCreateJobResponse,
  assertCreateUserRequest,
  assertCreateUserRequestJson,
  assertCreateUserResponse,
  assertDeleteJobRequest,
  assertDeleteJobRequestPathParameters,
  assertDeleteJobResponse,
  assertFile,
  assertGeneratePresignedUrlRequest,
  assertGeneratePresignedUrlRequestPathParameters,
  assertGeneratePresignedUrlRequestQueryStringParameters,
  assertGeneratePresignedUrlResponse,
  assertGetJobByIdRequest,
  assertGetJobByIdRequestPathParameters,
  assertGetJobByIdResponse,
  assertGetMetricsRequest,
  assertGetMetricsResponse,
  assertGetResultArchiveRequest,
  assertGetResultArchiveRequestPathParameters,
  assertGetResultArchiveResponse,
  assertGetUserRequest,
  assertGetUserResponse,
  assertJob,
  assertJobAdvancedParameters,
  assertJobStatus,
  assertJobStatusEntry,
  assertListInputRequest,
  assertListInputRequestPathParameters,
  assertListInputRequestQueryStringParameters,
  assertListInputResponse,
  assertListJobsRequest,
  assertListJobsResponse,
  assertListResultImagesRequest,
  assertListResultImagesRequestPathParameters,
  assertListResultImagesResponse,
  assertListResultRequest,
  assertListResultRequestPathParameters,
  assertListResultResponse,
  assertProtein,
  assertSubmitInputRequest,
  assertSubmitInputRequestPathParameters,
  assertSubmitInputRequestQueryStringParameters,
  assertSubmitInputResponse,
  assertSubmitJobRequest,
  assertSubmitJobRequestJson,
  assertSubmitJobRequestJsonAdvancedParameters,
  assertSubmitJobRequestJsonUseSpotInstance,
  assertSubmitJobRequestPathParameters,
  assertSubmitJobResponse,
  assertUpdateUserRequest,
  assertUpdateUserRequestJson,
  assertUpdateUserResponse,
  assertUser,
  assertUserMetrics,
  routes,
  validators
});
